import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState } from 'react';
import { Input, InputErrorMessage, InputLabel, RequiredAsterisk, TextInputWrapper, WordCount, } from './BKJTextArea.styled.js';
export const BKJTextArea = forwardRef((props, ref) => {
    const { label, error, maxLength = 500, required, disabled, onChange, className, width, height, ...rest } = props;
    const [charCount, setCharCount] = useState(props.value ? props.value.toLocaleString().length : 0);
    const countChars = (e) => {
        const text = e.target.value;
        setCharCount(text.length);
    };
    const handleChange = (e) => {
        if (onChange)
            onChange(e);
        countChars(e);
    };
    return (_jsxs(TextInputWrapper, { className: className, children: [label && (_jsxs(InputLabel, { disabled: disabled, children: [label, " ", required && _jsx(RequiredAsterisk, { children: "\u00A0*" })] })), _jsx(Input, { ref: ref, error: !!error, onChange: handleChange, maxLength: maxLength, disabled: disabled, width: width, height: height, ...rest }), _jsxs(WordCount, { disabled: disabled, error: error ? (Array.isArray(error) ? !!error.length : !!error) : false, children: [`${charCount}/${maxLength}`, error && Array.isArray(error) ? (error.map((err) => _jsx(InputErrorMessage, { children: err }, err))) : (_jsx(InputErrorMessage, { children: error }))] })] }));
});
//# sourceMappingURL=BKJTextArea.js.map